import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { getLanguageFromUniquePath, resolveSiteLanguage } from '@/utils/routing';
import { ensureNamespaces } from '@/i18n/config';
import { namespacesForPath } from '@/i18n/namespaces';

/** Keep i18n in sync with locale-unique paths like /sammenlign/ → da. */
const LanguageFromPath = () => {
  const { pathname, search } = useLocation();
  const { i18n } = useTranslation();

  useEffect(() => {
    const queryLang = resolveSiteLanguage(new URLSearchParams(search).get('lang'));
    if (queryLang) {
      if (i18n.language !== queryLang) {
        void ensureNamespaces(i18n, queryLang, namespacesForPath(pathname))
          .then(() => i18n.changeLanguage(queryLang));
      }
      return;
    }
    const pathLang = getLanguageFromUniquePath(pathname);
    if (pathLang && pathLang !== i18n.language) {
      void ensureNamespaces(i18n, pathLang, namespacesForPath(pathname))
        .then(() => i18n.changeLanguage(pathLang));
    }
  }, [pathname, search, i18n]);

  return null;
};

export default LanguageFromPath;
